module.exports = __webpack_public_path__ + "static/media/7、拉萨市城关区净土中央厨房建设项目专项债“一案两书”咨询-min.742dcc3d.jpg";